import gql from 'graphql-tag';

import type { EntityComplianceData } from 'src/data/compliance';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQueryComplianceForLongFormAssetsArgs } from 'src/types/backend';

import { FRAGMENT_LONG_FORM_ASSET_COMPLIANCE } from './schema';

const QUERY = gql`
  query ComplianceForLongFormAssets($longFormAssetIds: [ID!]!) {
    complianceForLongFormAssets(longFormAssetIds: $longFormAssetIds) {
      ...LongFormAssetCompliance
    }
  }
  ${FRAGMENT_LONG_FORM_ASSET_COMPLIANCE}
`;

type Variables = BackendQueryComplianceForLongFormAssetsArgs;
type Result = EntityComplianceData[];

export const queryComplianceForLongFormAssets = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
